export default __webpack_public_path__ + "static/media/DealShaker_Brochure_All_original.2bcc3d3f.jpg";